import { render, staticRenderFns } from "./electricStatistics.vue?vue&type=template&id=a95203b6&scoped=true"
import script from "./electricStatistics.vue?vue&type=script&lang=js"
export * from "./electricStatistics.vue?vue&type=script&lang=js"
import style0 from "./electricStatistics.vue?vue&type=style&index=0&id=a95203b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95203b6",
  null
  
)

export default component.exports